import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card p-3 mb-4" }
const _hoisted_2 = { class: "row g-2 align-items-end" }
const _hoisted_3 = { class: "col-md-6 col-sm-12" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = { class: "col-auto ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.translate('selectAreas')), 1),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.selectedItems.areaId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.areaId) = $event)),
          options: _ctx.areas,
          label: "areaName",
          "track-by": "areaName",
          "value-prop": "id",
          searchable: true,
          "can-deselect": false,
          "close-on-select": true,
          placeholder: _ctx.translate('selectAreas'),
          "no-results-text": _ctx.translate('noResultsFound')
        }, null, 8, ["modelValue", "options", "placeholder", "no-results-text"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light me-1",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}